function Spinner() {
  return <div className="loading"></div>;
}

export default Spinner;
